import jsPDF from "jspdf";
import {ColorUtil} from "oca-lib-web";

export default class PrintManager {

    // A4 measures 210 × 297 millimeters
    public static k = 72 / 25.4000508;
    public static pageLeft = 10;
    public static pageRight = 210 - 10;
    public static pageWidth = PrintManager.pageRight - PrintManager.pageLeft;
    public static pageTop = 10;
    public static xPadding = 5;
    public static yPadding = 5.5;
    public static spacing = 5;

    public x = 0;
    public y = 0;
    public startLeft = 0;
    public startTop = 0;

    public doc:jsPDF;
    public getDoc():jsPDF {
        return this.doc;
    }

    public initDoc() {
        this.doc = new jsPDF('portrait', 'mm', 'a4');
        this.x = 0;
        this.y = 0;
        this.startLeft = 0;
        this.startTop = 0;
    }

    public addImage(imageData:any, x:any, y:any, width:any, height:any) {
        this.doc.addImage(imageData, 'JPEG', x, y, width, height);
    }

    public addLineToDoc(text:any, attributes:PrintAttributes) {
        this.addToDoc(text, attributes);
        this.y += this.getLineHeight();
        this.x = this.startLeft;
    };

    public addToDoc(text:any, attributes:PrintAttributes) {
        switch (attributes.size) {
            case 'h1':
                this.doc.setFontSize(12);
                break;
            case 'h2':
                this.doc.setFontSize(10);
                break;
            case 'h3':
                this.doc.setFontSize(8);
                break;
            default:
                this.doc.setFontSize(12);
        }

        this.doc.setFontType(attributes.bold ? 'bold' : 'normal');
        this.setColor(attributes.color);

        //console.log(text);
        let width = attributes.width ? attributes.width : this.doc.getTextWidth(text.toString());
        let _x = this.x;
        let _y = this.y;

        switch (attributes.align) {
            case 'right':
                _x -= width;
                break;
            case 'center':
                _x -= width / 2;
                break;
            default:
                this.x += width;
        }
        var splitTitle = this.doc.splitTextToSize(text.toString(), PrintManager.pageWidth - (PrintManager.spacing*2));
        this.doc.text(_x, _y + this.getLineHeight() / 2, splitTitle);
    };

    public rect(color:any, x:any, y:any, width:any, height:any) {
        this.setColor(color);

        this.doc.rect(x, y, width, height, 'F');
    }

    public circle(color:any, x:any, y:any, radius:any) {
        this.setColor(color);
        this.doc.circle(x, y, radius, 'F');
    }

    public hLine(color:any, x:any, y:any, width:any) {
        this.setColor(color);
        this.doc.setLineWidth(0.25);
        this.doc.line(x, y, x + width, y);
    }

    public getLineHeight() {
        return this.doc.getLineHeight() / PrintManager.k;
    }

    public setColor(color:any) {
        switch (color) {
            case 'percentGreen':
                this.doc.setFillColor(1, 175, 1);
                this.doc.setDrawColor(1, 175, 1);
                this.doc.setTextColor(1, 175, 1);
                break;
            case 'percentRed':
                this.doc.setFillColor(212, 31, 56);
                this.doc.setDrawColor(212, 31, 56);
                this.doc.setTextColor(212, 31, 56);
                break;
            case 'black':
                this.doc.setFillColor(0, 0, 0);
                this.doc.setDrawColor(0, 0, 0);
                this.doc.setTextColor(0, 0, 0);
                break;
            case 'back':
                this.doc.setFillColor(246, 247, 251);
                this.doc.setDrawColor(246, 247, 251);
                this.doc.setTextColor(246, 247, 251);
                break;
            case 'white':
                this.doc.setFillColor(255, 255, 255);
                this.doc.setDrawColor(255, 255, 255);
                this.doc.setTextColor(255, 255, 255);
                break;
            case 'lightgrey':
                this.doc.setFillColor(228, 231, 243);
                this.doc.setDrawColor(228, 231, 243);
                this.doc.setTextColor(228, 231, 243);
                break;
            case 'darkgrey':
                this.doc.setFillColor(124, 131, 157);
                this.doc.setDrawColor(124, 131, 157);
                this.doc.setTextColor(124, 131, 157);
                break;
            case 'blue':
                this.doc.setFillColor(95, 149, 255);
                this.doc.setDrawColor(95, 149, 255);
                this.doc.setTextColor(95, 149, 255);
                break;
            case 'lightblue':
                this.doc.setFillColor(223, 234, 254);
                this.doc.setDrawColor(223, 234, 254);
                this.doc.setTextColor(223, 234, 254);
                break;
            case 'headerBlue':
                this.doc.setFillColor(21, 100, 255);
                this.doc.setDrawColor(21, 100, 255);
                this.doc.setTextColor(21, 100, 255);
                break;
            case 'headerGreen':
                this.doc.setFillColor(40, 179, 81);
                this.doc.setDrawColor(40, 179, 81);
                this.doc.setTextColor(40, 179, 81);
                break;
            case 'violet':
                this.doc.setFillColor(119, 111, 235);
                this.doc.setDrawColor(119, 111, 235);
                this.doc.setTextColor(119, 111, 235);
                break;
            case 'lightviolet':
                this.doc.setFillColor(228, 228, 255);
                this.doc.setDrawColor(228, 228, 255);
                this.doc.setTextColor(228, 228, 255);
                break;
            case 'green':
                this.doc.setFillColor(48, 229, 169);
                this.doc.setDrawColor(48, 229, 169);
                this.doc.setTextColor(48, 229, 169);
                break;
            default:
                let rgb = ColorUtil.hexToRgb(color);
                this.doc.setFillColor(rgb.r, rgb.g, rgb.b);
                this.doc.setDrawColor(rgb.r, rgb.g, rgb.b);
                this.doc.setTextColor(rgb.r, rgb.g, rgb.b);
        }
    }
}